export default [
  {
    title: '투명하고 안전한<br />데이터 관리',
    desc:
      '고객의 데이터는 고객의 소유이며, 엄격한 암호화를 거쳐 데이터센터에 보관됩니다. 어떠한 경우에도 고객의 동의 없는 데이터 접근이 불가능하도록 데이터센터 각은 투명하고 안전하게 데이터를 관리합니다.'
  },
  {
    title: '최고의 보안 시스템이 만드는<br />완벽한 서비스 연속성',
    desc:
      '데이터센터 각은 데이터 보호를 최우선 가치로 여기며, 글로벌 보안 위협에 대한 다양한 경험과 노하우를 갖춘 최고의 보안 전문가들이 구축한 보안 시스템을 가동하고 있습니다. 이를 통해 안전한 데이터 보호와 완벽한 서비스 연속성을 실현합니다.'
  },
  {
    title: '철저한<br />법규 준수',
    desc: '데이터센터 각은 더욱 안전하고 투명한 데이터 보호를 위해 관련 법률 가이드라인을 철저하게 준수합니다.'
  },
  {
    title: '미래를 위한<br />가치 창출',
    desc: '데이터를 지키는 활동은 개인과 지역, 국가 경쟁력을 넓히고, 지속 가능한 사회를 만들기 위한 필수 조건입니다. 데이터센터 각은 데이터 주권을 통한 지속 가능한 가치 창출에 앞장서고 있습니다.'
  }
];
